import "babel-polyfill";
import 'pusher-js';
import 'underscore';
import 'sprintf';
import 'uri-templates';

import moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
import { bbAuthorisation } from "./admin/bb_authorisation";

extendMoment(moment);

if (process.browser) {
    window.moment = moment;
}

import { halClient, dataCache, sharedHeader, BaseResource } from "./hal";
import sessionStorage from "./utils/storage/session_storage";
import { context } from "./constants/context";
import { emitter } from "./utils/emitter";
import { bbTimeZone } from "./utils/time_zone";
import { roles } from "./constants/user_roles";
import { reasonTypeCodes } from "./constants/reason_type_codes";
import { bookingStatusCodes } from "./constants/booking_status_codes";
import { attendanceStatusCodes } from "./constants/attendance_status_codes";
import { memberTypes } from "./constants/member_types";
import { companySettingsBookingTypes } from './constants/company_settings_booking_types.js';
import { translations } from "./constants/translations";
import { BBModel } from "./bb_model";
import { BBService } from "./bb_service";
import { Utils } from "./utils/utils";
import { BBAssets } from "./services/bb_assets";
import { ResourceSet } from "./collection/sets/resource_set"
import { PersonSet } from "./collection/sets/person_set";
import { ScheduleRules } from "./services/schedule_rules";
import { PusherFactory } from "./utils/pusher_factory"
import { Set } from "./collection/sets/set";
import { BaseFacet } from "./models/base_facet";
import HttpTrackerService from './utils/http_tracker';

export {

    BBModel,
    BBService,

    BBAssets,
    Utils,
    ScheduleRules,
    Set,
    PersonSet,
    ResourceSet,
    PusherFactory,

    bbAuthorisation,
    context,
    reasonTypeCodes,
    bookingStatusCodes,
    attendanceStatusCodes,
    memberTypes,
    companySettingsBookingTypes,
    roles,
    translations,
    emitter,
    moment,
    bbTimeZone,

    dataCache,
    halClient,
    sharedHeader,
    sessionStorage,
    BaseResource,
    BaseFacet,
    HttpTrackerService
}
